import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';
import css from './Table.GroupHeaderCell.css';

const GroupHeaderCell = ({ row, colSpan }) => {
    if (row.isEmptyState) {
        return (
            <td className={css.emptyStateCell} colSpan={colSpan}>
                {row.emptyStateComponent || <span className={css.emptyStateText}>{row.emptyStateText}</span>}
            </td>
        );
    }

    return (
        <td className={css.groupHeaderCell} colSpan={colSpan} onClick={row.onToggle}>
            <div className={classNames(css.content, { [css.expanded]: !row.isCollapsed })}>
                <div className={css.arrowWrapper}>
                    <Icon
                        name={row.isCollapsed ? 'chevron-right' : 'chevron-down'}
                        size={IconSizes.X_SMALL}
                        variant={IconVariants.ACTIVE}
                    />
                </div>
                <span className={css.title}>{row.groupTitle}</span>
            </div>
        </td>
    );
};

GroupHeaderCell.propTypes = {
    row: PropTypes.shape({
        groupTitle: PropTypes.string,
        isCollapsed: PropTypes.bool,
        isEmptyState: PropTypes.bool,
        emptyStateText: PropTypes.string,
        emptyStateComponent: PropTypes.node,
        onToggle: PropTypes.func,
    }),
    colSpan: PropTypes.number,
};

export default GroupHeaderCell;
